import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from '../../BaseComponent';
import { LayoutType } from '../../../constants/LayoutConstants';
import { PropertyEditorActions } from '../../../actions/PropertyEditorActions';
import { GlobalHelper } from '../../../utils/GlobalHelper';
import { CoreTooltip } from '../../CoreTooltip';
import { ClickButton } from '../../ClickButton';
import { PropertyChoiceList } from './PropertyChoiceList';

import core = egr.wcf.core;
import utils = egr.wcf.utils;

interface PropertyItemProps {
    active: boolean;
    choiceList: Array<core.prop.PropertyValue> | undefined;
    layoutType: LayoutType;
    property: core.prop.Property;
}

/*
    Child of PropertyClass-Component
    */
export class PropertyItem extends BaseComponent<PropertyItemProps, {}> {
    public render(): JSX.Element {
        const tName: string = this.props.property.getName();
        let tValueText: string | null = '';
        const tValue: core.prop.PropertyValue | null = this.props.property.getValue();
        let preview: JSX.Element | null = null;
        if (tValue != null) {
            tValueText = tValue.text;
            if (tValueText == null && this.props.property.type === core.prop.PropertyType.Length) {
                tValueText = GlobalHelper.getLocaleLengthString(tValue.value as number);
            } else if (tValueText == null || tValueText === '') {
                tValueText = this.props.property.getValueAsString();
            }
            const isWall: boolean = (
                this.props.property != null &&
                !utils.string.isNullOrEmpty(this.props.property.key) &&
                this.props.property.key.indexOf('room:Wall:') !== -1 &&
                this.props.property.type === core.prop.PropertyType.Length
            );
            if (isWall) {
                preview = (
                    <ClickButton
                        callback={() => {
                            if (this.props.property.key.indexOf('room:Wall:height') !== -1) {
                                GlobalHelper.roomManager.setWallHeight(tValue.value as number);
                            } else {
                                GlobalHelper.roomManager.setWallThickness(tValue.value as number);
                            }
                        }}
                        className="core-property-image-wall"
                    >
                        <CoreTooltip config={{label: t('Apply value to all walls'), posFix: 8}}/>
                    </ClickButton>
                );
            } else  if (tValue.largeIcon != null && tValue.largeIcon !== '') {
                preview = <div className="core-property-image" style={{backgroundImage: 'url(\'' + tValue.largeIcon + '\')'}}/>;
            } else if (tValue.smallIcon != null && tValue.smallIcon !== '') {
                preview = <div className="core-property-image" style={{backgroundImage: 'url(\'' + tValue.smallIcon + '\')'}}/>;
            }
        }
        let tChoiceList: JSX.Element | null = null;
        if (this.props.choiceList != null) {
            tChoiceList = <PropertyChoiceList property={this.props.property} choicelist={this.props.choiceList}/>;
        }
        return (
            <div
                className={
                    'core-config-item' +
                    (this.props.property.editable ? '' : ' core-config-item-disabled')
                }
                onClick={this.onPropertyClick}
            >
                <div
                    className={
                        'core-property core-property-flex' +
                        (preview != null ? ' core-property-has-image' : '') +
                        (this.props.property.choiceList ? ' core-property-expandable' : '') +
                        (this.props.choiceList != null ? ' expanded' : '')
                    }
                >
                    <div className="core-property-name" style={{maxWidth: '100%'}}>
                        <span style={{float: 'left'}}>{this.nameFix(tName.trim())}&nbsp;</span>
                        <span style={{float: 'left'}} className="core-property-value">{tValueText}</span>
                    </div>
                    {preview}
                </div>
                {tChoiceList}
            </div>
        );
    }

    protected onPropertyClick = (pEvent: React.MouseEvent) => {
        if (this.props.active) {
            PropertyEditorActions.onPropertyClick(null);
        } else {
            PropertyEditorActions.onPropertyClick(this.props.property);
        }
    };

    protected nameFix(value: string): string {
        if (value.lastIndexOf(' :') === (value.length - 2)) {
            return value.substring(0, value.length - 2) + ':';
        }
        if (value.lastIndexOf(':') === (value.length - 1)) {
            return value;
        }
        return value + ':';
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/propertyeditor/PropertyItem.tsx